import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { EarnVersion } from "../../../../../models/types/earn.types";

@Component({
  selector: "app-version-group-cell-renderer",
  templateUrl: "./version-group.renderer.html",
})
export class VersionGroupCellRenderer implements ICellRendererAngularComp {
  params!: ICellRendererParams;
  isExpanded: boolean = false;
  groupKey: string = "";
  itemCount: number = 0;
  hasPublished: boolean = false;
  hasDraft: boolean = false;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.isExpanded = params.node.expanded ?? false;
    this.groupKey = params.node.key ?? "";
    this.itemCount = params.node.allChildrenCount ?? 0;

    // Access the child rows to determine their statuses
    this.checkChildStatuses();
  }

  refresh(params: ICellRendererParams): boolean {
    this.isExpanded = params.node.expanded ?? false;
    this.checkChildStatuses();
    return true;
  }

  private checkChildStatuses(): void {
    this.hasPublished = false;
    this.hasDraft = false;

    if (this.params.node.allLeafChildren) {
      this.params.node.allLeafChildren.forEach((child) => {
        const data = child.data as EarnVersion;
        if (data) {
          if (data.status === "published") {
            this.hasPublished = true;
          } else if (data.status === "draft") {
            this.hasDraft = true;
          }
        }
      });
    }
  }

  toggleExpanded(): void {
    const currentState = this.params.node.expanded;
    this.params.node.setExpanded(!currentState);
    this.isExpanded = !currentState;
  }
}
